/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig as baseAppConfig } from './app/app.i18n.config';
import { AppComponent } from './app/app.component';
import 'moment/locale/zh-tw';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { ConfigLoaderService } from './app/shared/services/config-loader.service';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
registerLocaleData(zh);

function initializeApp(configLoader: ConfigLoaderService) {
  return () => {
    console.log('APP_INITIALIZER: 開始載入設定檔');
    return configLoader.load().then(() => {
      console.log('APP_INITIALIZER: 設定檔載入完成');
    });
  };
}

const appConfig: ApplicationConfig = {
  ...baseAppConfig,
  providers: [
    ...(baseAppConfig.providers ?? []),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigLoaderService],
      multi: true,
    },importProvidersFrom(FormsModule), provideAnimationsAsync(), provideHttpClient(),
  ],
};

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
